import React, { useEffect, useRef, useState } from 'react';
import aiImg from "../Utils/Images/ai.png";
import { InferenceClient } from '@huggingface/inference';
import { GPT_KEY } from '../Utils/constants';
import parse from 'html-react-parser';
import getChatQuery from '../Utils/getChatQuery';

const AiChatBar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');
    const [loading, setLoading] = useState(false);

    const messagesEndRef = useRef(null);
    const chatRef = useRef(null);   // ⭐ NEW

    const client = new InferenceClient(GPT_KEY);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages, loading]);


    // ⭐ CLOSE ON OUTSIDE CLICK
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (chatRef.current && !chatRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);


    const toggleChatBox = () => setIsOpen(!isOpen);

    const handleSend = async () => {
        if (!input.trim()) return;

        const gptQuery = getChatQuery(input);
        const newUserMsg = { role: "user", content: input };

        setMessages((prev) => [...prev, newUserMsg]);
        setInput('');
        setLoading(true);

        try {
            const gptResult = await client.chatCompletion({
                model: "meta-llama/Llama-3.1-8B-Instruct",
                messages: [{ role: "user", content: gptQuery }]
            });

            const gptReply = gptResult?.choices[0]?.message?.content;
            setMessages((prev) => [...prev, { role: "assistant", content: gptReply }]);

        } catch (error) {
            console.error("AI Error details-", error);
            setMessages((prev) => [
                ...prev,
                { role: "assistant", content: "Sorry, I couldn't generate a response. Please try again later." }
            ]);

        } finally {
            setLoading(false);
        }
    };

    return (
        <div 
            ref={chatRef}  // ⭐ IMPORTANT
            id='chatbox'
            className={`fixed right-4 bottom-4 lg:bottom-6 ${isOpen ? 'w-80 h-72 rounded-3xl text-white p-2 bg-black/30 dark:bg-gray-400 backdrop-filter backdrop-blur-sm dark:bg-opacity-10 border flex flex-col' : 'bg-transparent px-6 py-6'} z-[90]`}
        >
            {!isOpen && (
                <div onClick={toggleChatBox} className='w-10 h-10 cursor-pointer rounded-lg flex justify-center items-center border-2 border-coustomGreen'>
                    <img className='w-8 h-8 dark:invert' src={aiImg} alt='AI' />
                </div>
            )}

            {isOpen && (
                <>
                    <div className='flex'>
                        <button onClick={toggleChatBox} className="text-xl text-coustomGreen px-1 font-bold hover:text-pink-400">X</button>
                        <h3 className='ml-20'>AI Chatbot</h3>
                    </div>

                    <div className='flex-1 p-2 overflow-y-auto break-words max-w-full' style={{ scrollbarWidth: "thin" }}>
                        {messages.map((msg, index) => (
                            <div key={index} className="mb-2 p-2 border border-white rounded text-sm">
                                {parse(msg.content)}
                            </div>
                        ))}
                        {loading && (
                            <div className='mb-2 p-2 border border-gray-300 dark:border-gray-600 rounded text-sm animate-pulse'>
                                Loading...
                            </div>
                        )}
                        <div ref={messagesEndRef} />
                    </div>

                    <div className='flex'>
                        <form onSubmit={(e) => e.preventDefault()} className='flex items-center w-full p-2'>
                            <input
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                className='flex-1 h-8 px-3 bg-transparent border border-white rounded-l-full focus:outline-none placeholder:text-xs'
                                type='text'
                                placeholder='Curious about Dhairya skills? Type here..'
                            />
                            <button onClick={handleSend} className='p-1 w-8 h-8 border border-white border-l-0 rounded-r-full'>
                                <img className='invert' src='https://www.svgrepo.com/show/349679/arrow-up-right.svg' alt='Send' />
                            </button>
                        </form>
                    </div>
                </>
            )}
        </div>
    );
};

export default AiChatBar;
